import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const DEPARTMENT_BY_UUID_RESOURCE = "department" as const;
export const DEPARTMENT_BY_UUID_API_PATH = `/v1/${DEPARTMENT_BY_UUID_RESOURCE}/{uuid}` as const;

export type DepartmentByUuidParameters = paths[typeof DEPARTMENT_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type DepartmentByUuidResponse =
  paths[typeof DEPARTMENT_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useDepartmentByUuidQuery(uuid: string, options?: Options<DepartmentByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<DepartmentByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [DEPARTMENT_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<DepartmentByUuidResponse>(
        `/v1/${DEPARTMENT_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
